import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./numbercard.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FaCaretRight } from "react-icons/fa6";

const Card = (props) => {
  const renderDescription = (description) => {
    return description.split("\n").map((line, index) => (
      <span key={index}>
        {line.replace(/&nbsp;/g, "\u00A0")}
        <br />
      </span>
    ));
  };

  const renderTitle = (title) => {
    return title.split("\n").map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  };

  return (
    <div
      className="equality-card"
      style={{ backgroundColor: props.backgroundcolor }}
    >
      <div className="equality-card-circle-container">
        <div
          className="equality-card-circle"
          style={{ backgroundColor: props.circlbackgroundcolor }}
        >
          <p>{props.circlenumber}</p>
        </div>
        <div 
          className="hover-area hover-area-empower-quality"
          style={{ backgroundColor: props.circlbackgroundcolor,
          opacity:1 }}
        >
          <p className="tooltip-texts">{props.tooltip}</p>
          <FaCaretRight size={30} className="hover-area-arrow"
          style={{ color: props.circlbackgroundcolor,
          opacity:1 }}
          />
        </div>
      </div>
     
      <div>
        <h2
          className="equality-card-title"
          style={{ color: props.titlefontcolor, fontWeight: "bolder" }}
        >
          {renderTitle(props.title)}
        </h2>
        <p
          className="equality-card-description"
          style={{ color: props.fontcolor }}
        >
          {renderDescription(props.description)}
        </p>
      </div>
    </div>
  );
};

const CustomPrevArrow = ({ onClick }) => (
  <div onClick={onClick} className="water-arrow water-left-arrow">
    <FontAwesomeIcon icon={faChevronLeft} />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div onClick={onClick} className="water-arrow water-right-arrow">
    <FontAwesomeIcon icon={faChevronRight} />
  </div>
);

const Home = () => {
  const cards = [
    {
      title: "\n17%",
      titlefontcolor: "#313893",
      description:
        "Slight increase in leadership positions held by women and on track for 30% target",
      backgroundcolor: "#C5F7E8",
      fontcolor: "#313893",
      circlenumber: "S2",
      circlbackgroundcolor: "#3CE5B2",
      tooltip:"30% of our Leadership Positions to be held by Women"
    },
    {
      title: "\n35%",
      titlefontcolor: "#313893",
      description:
        "Slight increase in female supervisors, halfway to achieving the target",
      backgroundcolor: "#C5F1F7",
      fontcolor: "#313893",
      circlenumber: "S3",
      circlbackgroundcolor: "#3CB4E5",
      tooltip:"70% of Facility Supervisory Positions to be held by Women"
    },
  ];

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    centerPadding: "10px",
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          autoplay: true,
          infinite: true,
          arrows: true,
          prevArrow: <CustomPrevArrow />,
          nextArrow: <CustomNextArrow />,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Slider className="equality-slider" {...settings}>
      {cards.map((card, index) => (
        <div key={index}>
          <Card
            title={card.title}
            description={card.description}
            backgroundcolor={card.backgroundcolor}
            fontcolor={card.fontcolor}
            circlenumber={card.circlenumber}
            circlbackgroundcolor={card.circlbackgroundcolor}
            titlefontcolor={card.titlefontcolor}
            tooltip={card.tooltip}
          />
        </div>
      ))}
    </Slider>
  );
};

export default Home;
